module.exports = [
	{
		path: 'filesystem/',
		name: 'Filesystem',
		component: () => import('@/pages/filesystem/explorer/explorer_tabs.vue'),
		meta: {
			label: 'File System',
			icon: 'search',
			description: `Navigateur de fichiers présents sur nos serveurs d'achivage.`
		}
	},
	{
		path: 'finder/',
		name: 'Finder',
		component: () => import('@/pages/filesystem/explorer/explorer_tabs.vue'),
		meta: {
			label: 'Finder',
			icon: 'search',
			description: `Rechercher l'emplacement d'un asset depuis sa référence Suifa`
		}
	},
	{
		path: 'assets/',
		name: 'Assets',
		component: () => import('@/pages/filesystem/explorer/explorer_tabs.vue'),
		meta: {
			label: 'Assets',
			icon: 'title',
			description: `Rechercher un asset depuis son titre ou différents critères`
		}
	},
	{
		path: 'cards/',
		name: 'Cards',
		component: () => import('@/pages/filesystem/explorer/explorer_tabs.vue'),
		meta: {
			label: 'Cards',
			icon: 'title',
			description: `Rechercher une carte depuis son titre ou différents critères`
		}
	},
	{
		path: '/babel/card/:id',
		name: 'Babel Card',
		component: () => import('@/pages/babel/card.vue'),
		meta: {
			label: 'Babel Card',
			icon: 'title',
			description: 'Accéder aux données d\'une Babel card',
			has_home_link: true,
			disabled: true
		}
	},
	{
		path: 'profiles/',
		name: 'Profiles',
		component: () => import('@/pages/filesystem/explorer/explorer_tabs.vue'),
		meta: {
			label: 'Profiles',
			icon: 'person',
			description: `Rechercher un profil utilisateur depuis différents critères`
		}
	},
	{
		path: 'lifecycles/',
		name: 'Lifecycles',
		component: () => import('@/pages/filesystem/explorer/explorer_tabs.vue'),
		meta: {
			label: 'Cycles de vie',
			icon: 'place',
			description: `Rechercher un emplacement de fichier depuis différents critères`
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/routes_explorer.js